// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"5f7df9f2","453":"0e0c00bc","455":"7d6ff2dc","977":"bede9fd9"}[chunkId] + ".chunk.js";
};